import { Behavior, AttachmentRule } from './types';
import { WorldMaker } from '../WorldMaker';

export class ColorOnClickBehavior extends Behavior {
  private colors: string[] = ['red', 'blue', 'green', 'yellow', 'purple', 'orange', 'pink', 'cyan', 'magenta', 'lime'];
  private currentColorIndex: number = 0;
  private clickHandler: (event: Event) => void;

  static getAttachmentRules(): AttachmentRule[] {
    return [
      { type: 'class', selector: 'color-on-clicked' }
    ];
  }

  constructor(element: Element, world: WorldMaker) {
    super(element, world);
    this.clickHandler = this.handleClick.bind(this);
  }

  onAttach(): void {
    console.log('ColorOnClickBehavior attached to:', this.element);
    this.element.addEventListener('click', this.clickHandler);
    // Set initial color if none exists
    if (!this.element.getAttribute('color')) {
      this.element.setAttribute('color', this.colors[0]);
    }
  }

  onDetach(): void {
    console.log('ColorOnClickBehavior detached from:', this.element);
    this.element.removeEventListener('click', this.clickHandler);
  }

  private handleClick(event: Event): void {
    event.preventDefault();
    this.currentColorIndex = (this.currentColorIndex + 1) % this.colors.length;
    this.element.setAttribute('color', this.colors[this.currentColorIndex]);
    console.log(`Element clicked! Changed color to: ${this.colors[this.currentColorIndex]}`);
  }

  tick(deltaTime: number): void {
    // No continuous animation needed for click behavior
  }
} 